export const APPINSTALL_URL = {
  ANDROID: {
    qrCode: '/cc/image/installQR/town_qr_aos.png',
    buttonImage: '/cc/image/installQR/aos_download_btn.png',
  },
  IOS: {
    qrCode: '/cc/image/installQR/town_qr_ios.png',
    buttonImage: '/cc/image/installQR/ios_download_btn.png',
  },
  DOWNLOAD_URL: {
    android: 'https://play.google.com/store/apps/details?id=kr.co.proptier.town&pcampaignid=web_share',
    ios: 'https://apps.apple.com/kr/app/이실장-최신-매물-정보부터-매일경제-뉴스까지/id6736497502',
  },
} as const;
